import React, { useId } from 'react';

/**
 * Yeap Cloud 品牌标识（移植自官网 website/src/components/ui/Logo.vue）
 *
 * Props:
 *  - collapsed: 只显示图形标（侧边栏折叠时）
 *  - invert:    文字反白（深色底，如登录页品牌栏）
 *  - size:      图形标边长（默认 28）
 *  - suffix:    文字后缀，如 "控制台"
 */
const BrandLogo = ({ collapsed = false, invert = false, size = 28, suffix, style, className }) => {
    const gid = `yc-logo-g-${useId().replace(/:/g, '')}`;
    return (
        <span
            className={`brand-logo${invert ? ' brand-logo--invert' : ''}${className ? ` ${className}` : ''}`}
            style={{ display: 'inline-flex', alignItems: 'center', gap: 10, ...style }}
        >
            <svg width={size} height={size} viewBox="0 0 30 30" aria-hidden="true" style={{ flexShrink: 0 }}>
                <defs>
                    <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stopColor="#2357ff" />
                        <stop offset="0.6" stopColor="#6a5cff" />
                        <stop offset="1" stopColor="#18c2e8" />
                    </linearGradient>
                </defs>
                <rect x="1" y="1" width="28" height="28" rx="8" fill={`url(#${gid})`} />
                <path d="M8.5 9l6.5 7.2L21.5 9M15 16.2V22" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="22.6" cy="7.4" r="2.3" fill="#ff6a2b" stroke="#fff" strokeWidth="1.2" />
            </svg>
            {!collapsed && (
                <span className="brand-logo-word">
                    <b>Yeap</b> Cloud
                    {suffix && <span className="brand-logo-suffix">{suffix}</span>}
                </span>
            )}
            {collapsed && <span className="sr-only">Yeap Cloud</span>}
        </span>
    );
};

export default BrandLogo;
